import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './Videos.css';

const Videos = () => {
  const { t } = useTranslation();
  const [selectedVideo, setSelectedVideo] = useState(null);

  // Guide Videos Data
  const guideVideos = [
    {
      id: 'guide1',
      youtubeId: 'dQw4w9WgXcQ',
      title: 'Getting Started with Land Tracker',
      language: 'English',
      duration: '5:30',
      thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg'
    },
    {
      id: 'guide2',
      youtubeId: 'dQw4w9WgXcQ',
      title: 'How to Add Your First Property',
      language: 'English',
      duration: '8:15',
      thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg'
    },
    {
      id: 'guide3',
      youtubeId: 'dQw4w9WgXcQ',
      title: 'GPS Boundary Capture Tutorial',
      language: 'English',
      duration: '12:45',
      thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg'
    },
    {
      id: 'guide4',
      youtubeId: 'dQw4w9WgXcQ',
      title: 'AI-Watchman Setup Guide',
      language: 'English',
      duration: '7:20',
      thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg'
    },
    {
      id: 'guide5',
      youtubeId: 'dQw4w9WgXcQ',
      title: 'Document Management Features',
      language: 'Hindi',
      duration: '6:50',
      thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg'
    },
    {
      id: 'guide6',
      youtubeId: 'dQw4w9WgXcQ',
      title: 'Property Valuation & Analytics',
      language: 'English',
      duration: '10:30',
      thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg'
    }
  ];

  // Testimonial Videos Data
  const testimonialVideos = [
    {
      id: 'testimonial1',
      youtubeId: 'dQw4w9WgXcQ',
      title: 'How Land Tracker Saved My Property',
      language: 'English',
      duration: '3:45',
      author: 'Rajesh Kumar',
      location: 'Mumbai, India',
      thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg'
    },
    {
      id: 'testimonial2',
      youtubeId: 'dQw4w9WgXcQ',
      title: 'Best Property Management App',
      language: 'Hindi',
      duration: '2:30',
      author: 'Priya Sharma',
      location: 'Delhi, India',
      thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg'
    },
    {
      id: 'testimonial3',
      youtubeId: 'dQw4w9WgXcQ',
      title: 'AI-Watchman Caught Trespassers',
      language: 'English',
      duration: '4:20',
      author: 'Amit Patel',
      location: 'Bangalore, India',
      thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg'
    },
    {
      id: 'testimonial4',
      youtubeId: 'dQw4w9WgXcQ',
      title: 'Perfect for Farmers',
      language: 'Hindi',
      duration: '3:15',
      author: 'Suresh Yadav',
      location: 'Punjab, India',
      thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg'
    },
    {
      id: 'testimonial5',
      youtubeId: 'dQw4w9WgXcQ',
      title: 'GPS Accuracy is Amazing',
      language: 'English',
      duration: '2:50',
      author: 'Neha Singh',
      location: 'Pune, India',
      thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg'
    },
    {
      id: 'testimonial6',
      youtubeId: 'dQw4w9WgXcQ',
      title: 'Managing Multiple Properties Made Easy',
      language: 'English',
      duration: '5:10',
      author: 'Vikram Malhotra',
      location: 'Jaipur, India',
      thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg'
    }
  ];

  const openVideoModal = (video) => {
    setSelectedVideo(video);
    document.body.style.overflow = 'hidden';
  };

  const closeVideoModal = () => {
    setSelectedVideo(null);
    document.body.style.overflow = 'auto';
  };

  const VideoCard = ({ video, isTestimonial = false }) => (
    <div className="video-card" onClick={() => openVideoModal(video)}>
      <div className="video-thumbnail">
        <img src={video.thumbnail} alt={video.title} />
        <div className="play-overlay">
          <div className="play-button">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M8 5v14l11-7z"/>
            </svg>
          </div>
        </div>
        <span className="video-duration">{video.duration}</span>
      </div>
      <div className="video-info">
        <h3 className="video-title">{video.title}</h3>
        <div className="video-meta">
          <span className="video-language">
            <span className="language-icon">🌐</span>
            {video.language}
          </span>
          {isTestimonial && (
            <div className="video-author">
              <span className="author-icon">👤</span>
              <div>
                <div className="author-name">{video.author}</div>
                <div className="author-location">{video.location}</div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );

  return (
    <div className="videos-page">
      <div className="videos-hero">
        <div className="container">
          <h1>Video Library</h1>
          <p>Learn how to use Land Tracker and hear success stories from our users</p>
        </div>
      </div>

      <div className="container">
        {/* Guide Videos Section */}
        <section className="videos-section">
          <div className="section-header">
            <div className="section-icon">📚</div>
            <div>
              <h2>Guide Videos</h2>
              <p>Step-by-step tutorials to help you master Land Tracker</p>
            </div>
          </div>
          <div className="videos-grid">
            {guideVideos.map(video => (
              <VideoCard key={video.id} video={video} />
            ))}
          </div>
        </section>

        {/* Testimonial Videos Section */}
        <section className="videos-section">
          <div className="section-header">
            <div className="section-icon">💬</div>
            <div>
              <h2>User Testimonials</h2>
              <p>Real stories from real users who trust Land Tracker</p>
            </div>
          </div>
          <div className="videos-grid">
            {testimonialVideos.map(video => (
              <VideoCard key={video.id} video={video} isTestimonial={true} />
            ))}
          </div>
        </section>
      </div>

      {/* Video Modal */}
      {selectedVideo && (
        <div className="video-modal" onClick={closeVideoModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeVideoModal}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M18 6L6 18M6 6l12 12"/>
              </svg>
            </button>
            <div className="video-wrapper">
              <iframe
                src={`https://www.youtube.com/embed/${selectedVideo.youtubeId}?autoplay=1`}
                title={selectedVideo.title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
            <div className="modal-info">
              <h3>{selectedVideo.title}</h3>
              <div className="modal-meta">
                <span className="modal-language">
                  <span className="language-icon">🌐</span>
                  {selectedVideo.language}
                </span>
                <span className="modal-duration">
                  <span className="duration-icon">⏱️</span>
                  {selectedVideo.duration}
                </span>
              </div>
              {selectedVideo.author && (
                <div className="modal-author">
                  <span className="author-icon">👤</span>
                  <div>
                    <strong>{selectedVideo.author}</strong>
                    <span> • {selectedVideo.location}</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Videos;
